import { render, staticRenderFns } from "./html-widget.vue?vue&type=template&id=3caef158"
import script from "./html-widget.vue?vue&type=script&lang=ts"
export * from "./html-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports